<template>
    <div  class="container select-issue">
        <v-icon style="margin-left: 5px" :color="getColorIcon()" :disabled="disable">mdi-text-box-check-outline</v-icon>
        <v-select
                v-model="issue"
                v-bind:class="[disableIssue ||issue===null  ? disActiveIssues : activeIssues]"
                :style="'width:'+width+'px'+';'+'height:'+height+'px'"
                :disabled="issues.length===0|| (disableIssue && !manualTimes) || !$store.state.isIntegrationSet"
                rounded
                class="text-truncate"
                color="#00CE81"
                item-color="green"
                chips
                :items="originalIssues"
                dense
                placeholder="مسئله"
                item-text="text"
                item-value="id"
                hide-details
                height="15" clearable
                @blur="eventOpen()"
                @focus="eventOpen()"
                @change="issuesChange(issue)"
                @focusin="callOpen"
        >
          <template  #selection="{ item }">
            <v-chip v-if="issue!==''" class="text-truncate" small text-color="white" height="21px" :color="getColorChip(item.type)">{{item.id}}#-{{item.title}}</v-chip>
          </template>
          <template  slot="item" slot-scope="{ item }">
            <div  style="display: flex;justify-content: flex-start;align-items: center">
              <v-chip class="justify-start " style="" small text-color="white" height="21px" :color="getColorChip(item.type)">{{item.id}}#</v-chip>
              <div style="font-family: iranYekan !important;font-size: 10px !important; text-overflow: ellipsis; width: 100px; overflow:hidden;" class="mr-2 ">{{item.title}}</div>
            </div>
          </template>
            <template v-if="issue" v-slot:append>
                <v-icon v-if="openAutoComplete" color="#1DCCBB">mdi-chevron-up </v-icon>
                <v-icon v-else color="#1DCCBB">mdi-chevron-down </v-icon>
            </template>
            <template v-else v-slot:append>
                <v-icon v-if="openAutoComplete" color="#BBBBBB">mdi-chevron-up</v-icon>
                <v-icon v-else color="#BBBBBB">mdi-chevron-down</v-icon>
            </template>
        </v-select>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
    export default {
        name: "selectIssue",
        data:()=>({
          projectItem: '',
          friends:'',
          issue:'',
          issues:[
            {type:'feature',id:'25',title:'ahmad reza'},
            {type:'bog',id:'26',title:'بنشیبتمسیب'},
            {type:'bog',id:'27',title:'fdfasdf asd fasdf asdf sadf sdaf dsfsad fasdf sad f  '},
            {type:'support',id:'28',title:'ali'},
            {type:'bog',id:'29',title:'mohammad'},
            {type:'feature',id:'30',title:'bib'},
            {type:'Support',id:'31',title:'apple'},
            {type:'feature',id:'32',title:'red'},
          ],
          activeIssues:'active-issues',
          disActiveIssues:'dis-active-issues',
          openAutoComplete:false,
        }),
        props: {
          disableIssue: {
            type :Boolean,
            default:true,
          },
          manualTimes:{
            type:Boolean,
            default:false
          },
          share:{
            type:Object,
            default(){return{}}
          },
          usedIssue:Boolean,
          disable: {
                type: Boolean,
                default: false
            },
          width:{
              type:Number,
            },
          height:{
            type:Number,
            default:0,
          },
          project: {}
        },
      mounted() {
          this.projectItem = this.project;
          this.callOpen();
        if (this.height === 0) {
          this.height === 'inherit';
        }
        if (this.share !== undefined) {
        if (this.share.id !== undefined) {
          this.issue = this.share.id
        }

        }

      },
      methods:{
          ...mapActions({
            getIssues: 'issues/fetchIssues'
          }),
        async callOpen(){
          if (this.projectItem.id !== undefined && this.projectItem.id !== null){
              await this.getIssues({project_id: this.projectItem.id});
            }
        },
        eventOpen(){
          this.openAutoComplete = !this.openAutoComplete
        },
        getColorIcon() {
          return this.disableIssue||this.issue===null ? '#BBBBBB' : '#1DCCBB';
        },
        getColorChip(type) {
          if(type==='Feature'){
            return 'rgb(35, 143, 243)'
          }else if(type==='Bug'){
            return 'error'
          }else{
            return  '#029934'
          }
        },
        issuesChange(issue){
          console.log('issue', issue);
          this.$emit('refreshIssue',issue)
        }
      },
      computed: {
         ...mapGetters({
            originalIssues:'issues/get_issues'
         }),
      },
      watch:{
          issue(){

          },
          usedIssue(){
            this.share ={}
            this.issue=''
          },
        project(newValue){
            this.projectItem = newValue;
        }
      }
    }
</script>
<style>
.v-input__icon--clear{
  height: inherit !important;
  color: red !important;

}
.v-input__icon--clear .theme--light.v-icon{
  color:red !important;
}
.select-issue .v-select__slot{
  height: inherit;
}
.select-issue .select-issue .v-select__slot{
  height: inherit;
}
.select-issue .v-select .v-chip {
  flex: 0 1 auto;
  margin: 7px 0;
}
.select-issue .v-select.v-select--chips .v-select__selections{
  height: inherit;
}
.select-issue .v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner{
  height: inherit;
}
.select-issue .v-text-field .v-input__append-inner {
  margin-top: 0;
}
.select-issue .v-chip .v-chip__content {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
}
.select-issue .v-text-field--rounded > .v-input__control > .v-input__slot{
  padding: 0 10px 0 5px;
}
</style>

<style scoped>
    .container{
        display: flex;
        justify-content: center;
        align-content: center;
    }
    .active-issues{
      border:1px solid #00CE81 ;
      padding: 10px 0;
      background-color: white;
      font-size: 0.875rem;
      font-family: iranYekan;
      color: #5A5A5A;
    }
    .dis-active-issues{
      border:1px solid #BBBBBB;
      padding: 10px 0;
      font-size: 0.75rem;
      font-family: iranYekan;
      color: #BBBBBB;
    }
</style>
